module.exports = __webpack_public_path__ + "static/img/10042U_4_5_6_C_20230520_LC.75d180b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10042U_4_5_6_C_20230520_LC.png
// module id = Q42r
// module chunks = 0